// Crash queue: stored first, sent after. Pure logic over an injected storage (localStorage in the app,
// a Map stub in tests). Caps: 50 entries, 7 days; the same fingerprint within 1 minute is dropped.
import { fingerprint } from './scrub.mjs';

export const CRASH_KEY = 'ux_crash_queue';
export const MAX_CRASHES = 50;
export const MAX_AGE_MS = 7 * 24 * 3600 * 1000;
export const DEDUPE_MS = 60 * 1000;

export function readQueue(storage) {
  try {
    const arr = JSON.parse(storage.getItem(CRASH_KEY) || '[]');
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

export function writeQueue(storage, q) {
  try {
    if (q.length) storage.setItem(CRASH_KEY, JSON.stringify(q));
    else storage.removeItem(CRASH_KEY);
  } catch {
    /* storage full or blocked: the in-memory send still goes */
  }
}

export function prune(q, now) {
  const fresh = q.filter((e) => e && e.report && now - (e.queued_at || 0) < MAX_AGE_MS);
  return fresh.length > MAX_CRASHES ? fresh.slice(fresh.length - MAX_CRASHES) : fresh;
}

// Last time each fingerprint was queued (in memory, survives queue removal after a successful send).
const lastSeen = new Map();

export function resetDedupe() {
  lastSeen.clear();
}

// Returns the queued entry, or null when it was a duplicate within DEDUPE_MS.
export function enqueue(storage, report, now = Date.now()) {
  const fp = fingerprint(report);
  const q = prune(readQueue(storage), now);
  const prev = lastSeen.get(fp);
  const dupInQueue = q.some((e) => e.fp === fp && now - e.queued_at < DEDUPE_MS);
  if ((prev != null && now - prev < DEDUPE_MS) || dupInQueue) {
    writeQueue(storage, q);
    return null;
  }
  lastSeen.set(fp, now);
  const entry = { id: `${now.toString(36)}-${Math.random().toString(36).slice(2, 8)}`, fp, queued_at: now, report };
  q.push(entry);
  writeQueue(storage, prune(q, now));
  return entry;
}

export function remove(storage, id) {
  writeQueue(storage, readQueue(storage).filter((e) => e.id !== id));
}
